import { TextInput } from "react-admin";
import { styled } from "@mui/material/styles";
import DisableHandleKeyDown from "./DisableHandleKeyDown";
const CustomSearchText = styled(TextInput)(({ theme }) => ({
  marginLeft: "20px",
  "& .MuiInputBase-root::before": {
    content: '"and"',
    fontSize: "12px",
    display: "block",
    height: "30px",
    width: "30px",
    marginLeft: "-30px",
  },
}));

const CustomFilterText = ({ ...props }) => {
  return (
    <CustomSearchText
      source={props.source}
      {...props}
      variant="outlined"
      onKeyDown={DisableHandleKeyDown}
    />
  );
};
export default CustomFilterText;
